'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSeed$002dId$0024 from "./presto.types$-Seed-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$57() {
  this.aHj = null;
  this.aHh = null;
  this.aHi = false;
  this.aHf = null;
  this.aHg = false;
  this.aHk = false;
  this.aHl = false;
  this.aHj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$57 as $c_Lpresto_CredentialsView$$anon$57 };
$p = $c_Lpresto_CredentialsView$$anon$57.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$57;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$57() {
}
export { $h_Lpresto_CredentialsView$$anon$57 as $h_Lpresto_CredentialsView$$anon$57 };
$h_Lpresto_CredentialsView$$anon$57.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aHj;
});
$p.t = (function() {
  if ((!this.aHi)) {
    this.aHh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("seed", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHi = true;
  }
  return this.aHh;
});
$p.ag = (function() {
  if ((!this.aHg)) {
    this.aHf = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSeed$002dId$0024.$m_Lpresto_types$SeedId$().csZ(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHg = true;
  }
  return this.aHf;
});
$p.v = (function() {
  if ((!this.aHl)) {
    this.aHk = false;
    this.aHl = true;
  }
  return this.aHk;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$57 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$57, "presto.CredentialsView$$anon$57", ({
  G6: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$57 as $d_Lpresto_CredentialsView$$anon$57 };
//# sourceMappingURL=presto.-Credentials-View$$anon$57.js.map
